export default "__VITE_ASSET__CanG_2Tz__"